import * as React from 'react';
import { Box, useTheme } from '@mui/material';
import { designTokens } from '../Theme.design-tokens';

var TitleBar = function TitleBar() {
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: designTokens.colors.blue500,
      width: '2px',
      marginRight: "".concat(theme.spacing(1)),
      marginTop: "".concat(theme.spacing(0.5)),
      marginBottom: "".concat(theme.spacing(0.5))
    }
  });
};

export default TitleBar;
//# sourceMappingURL=index.js.map